
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ski-gear-storage",
      function () {
        return require("private-next-pages/ski-gear-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ski-gear-storage"])
      });
    }
  